"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _chip = _interopRequireDefault(require("./chip/chip"));

const ChipList = props => {
  const {
    chips,
    onDelete
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "chip-list"
  }, chips.map(chip => /*#__PURE__*/_react.default.createElement(_chip.default, {
    value: chip,
    onDelete: () => onDelete(chip),
    key: chip
  })));
};

ChipList.propTypes = {
  chips: _propTypes.default.arrayOf(_propTypes.default.string),
  onDelete: _propTypes.default.func.isRequired
};
ChipList.defaultProps = {
  chips: []
};
var _default = ChipList;
exports.default = _default;